import React from 'react';
import { styled } from '@glitz/react';
import { CircleFilled12x12, CircleUnfilled12x12 } from 'Shared/Icons/Circle';
import * as style from 'Shared/Style';

const circleNumbers = [1, 2, 3, 4, 5];
type PropType = {
  numberToFill: number;
};

const Wrap = styled.div({
  display: 'flex', alignItems: 'center', gap: '8px'
})

const CircleWrap = styled.span({
  display: 'flex', alignItems: 'center', height: '100%'
})

const Filled = styled(CircleFilled12x12, {
  color: style.colors.brandColors.yellow
})

const Unfilled = styled(CircleUnfilled12x12, {
  color: style.colors.brandColors.yellow
})

const FillableCircles = (props: PropType) => {
  const numberToFill = props.numberToFill || 0;

  return (
    <Wrap>
      {circleNumbers.map(number => {
        return (
          <CircleWrap key={number}>
            {numberToFill >= number ? (
              <Filled />
            ) : (
              <Unfilled />
            )}
          </CircleWrap>
        );
      })}
    </Wrap>
  );
};

export default FillableCircles;
